/**
 * Payment terms ("Betalningsvillkor") of orders, agreements and framework agreements
 *
 * The stored value is the word itself, per country (se / no). Choosing "Fritext" in the
 * dropdown stores the typed text instead, so any value that is not one of the country's
 * standard words is freetext. The order modal and the framework agreement form both use
 * these options, which lets a framework agreement fill in the order's payment terms.
 */
const PAYMENT_TERMS = {
  se: [
    { value: "Årsvis", label: "admin_order_alarm.payment_annually" },
    { value: "Halv år", label: "admin_order_alarm.payment_half_year" },
    { value: "Kvartal", label: "admin_order_alarm.payment_quarter" },
    { value: "Månad", label: "admin_order_alarm.payment_monthly" },
  ],
  no: [
    { value: "Årlig", label: "admin_order_alarm.payment_annually" },
    { value: "Halvårlig", label: "admin_order_alarm.payment_half_year" },
    { value: "Kvartalsvis", label: "admin_order_alarm.payment_quarter" },
    { value: "Månedlig", label: "admin_order_alarm.payment_monthly" },
  ],
};

// Dropdown marker for the freetext choice (never stored as the final value)
const FREETEXT_MARKER = { se: "__fritext__", no: "__fritekst__" };

const countryKey = (country) => (country === "no" ? "no" : "se");

export function isPaymentTermsFreetextMarker(value) {
  return value === FREETEXT_MARKER.se || value === FREETEXT_MARKER.no;
}

// [{ value, name }] for a BaseSelect; t is the component's $t
export function paymentTermsOptions(country, t) {
  const key = countryKey(country);
  return [
    ...PAYMENT_TERMS[key].map((o) => ({ value: o.value, name: t(o.label) })),
    { value: FREETEXT_MARKER[key], name: t("admin_order_alarm.payment_freetext") },
  ];
}

// Stored value -> the dropdown choice + freetext for the given country
export function splitPaymentTerms(value, country) {
  const key = countryKey(country);
  if (!value) return { payment_terms: "", payment_terms_freetext: "" };
  if (isPaymentTermsFreetextMarker(value)) return { payment_terms: FREETEXT_MARKER[key], payment_terms_freetext: "" };
  if (PAYMENT_TERMS[key].some((o) => o.value === value)) return { payment_terms: value, payment_terms_freetext: "" };
  return { payment_terms: FREETEXT_MARKER[key], payment_terms_freetext: value };
}

// Dropdown choice + freetext -> the value to store
export function joinPaymentTerms(paymentTerms, freetext) {
  return isPaymentTermsFreetextMarker(paymentTerms) ? (freetext || "").trim() : paymentTerms || "";
}
